import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-714dd80e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = {
  key: 0,
  style: {"float":"right"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-right icon-redirect" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "row",
  style: {"height":"50px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "row",
  style: {"height":"140px"}
}
const _hoisted_8 = ["hidden"]
const _hoisted_9 = {
  key: 2,
  class: "card-body livereading-card mt-4 p-3"
}
const _hoisted_10 = { class: "d-flex flex-wrap justify-content-around align-items-center" }
const _hoisted_11 = { class: "alarm-icon-container" }
const _hoisted_12 = ["title"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["title"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["title"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = {
  key: 3,
  class: "row"
}
const _hoisted_26 = ["hidden"]
const _hoisted_27 = {
  key: 4,
  class: "card-body livereading-card mt-4"
}
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "alarm-icon-container" }
const _hoisted_30 = ["title"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["title"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["title"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = ["title"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChartJs = _resolveComponent("ChartJs")!

  return (_openBlock(), _createElementBlock("div", {
    class: "card",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openPage()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.equipment.name) + " ", 1),
      (_ctx.type == 'basic')
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (_ctx.isShowOneMin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backTo30min())),
              style: {"cursor":"pointer"},
              class: "ml-5 mt-3"
            }, [
              _hoisted_6,
              _createTextVNode(" Back")
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == 'basic')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "col position-relative",
              hidden: _ctx.isShowOneMin
            }, [
              _createVNode(_component_ChartJs, {
                options: _ctx.option,
                onChartjsOnlick: _ctx.min30Onclick,
                style: {"height":"50px"}
              }, null, 8, ["options", "onChartjsOnlick"])
            ], 8, _hoisted_8)
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == 'basic')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipment.sensors, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "mb-1 text-center",
                  key: index
                }, [
                  _createElementVNode("b", null, [
                    _createElementVNode("span", {
                      class: "dot",
                      style: _normalizeStyle('background: ' + item.color)
                    }, null, 4),
                    _createTextVNode(" " + _toDisplayString(item.value) + " ", 1),
                    _createElementVNode("span", _hoisted_11, [
                      (_ctx.status(item.last_reading) && item.alarm_type == 77)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "alarm-icon text-warning",
                            title: item.message
                          }, _hoisted_14, 8, _hoisted_12))
                        : (_ctx.status(item.last_reading) && item.alarm_type == 78)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "alarm-icon text-danger",
                              title: item.message
                            }, _hoisted_17, 8, _hoisted_15))
                          : (_ctx.status(item.last_reading))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                class: "alarm-icon text-success",
                                title: item.message
                              }, _hoisted_20, 8, _hoisted_18))
                            : (!_ctx.status(item.last_reading))
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 3,
                                  class: "alarm-icon text-black-50",
                                  title: item.message
                                }, _hoisted_23, 8, _hoisted_21))
                              : _createCommentVNode("", true)
                    ])
                  ]),
                  _hoisted_24,
                  _createElementVNode("small", null, _toDisplayString(item.name) + " (" + _toDisplayString(item.unit) + ")", 1)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == 'advance')
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", {
              class: "col position-relative",
              hidden: _ctx.isShowOneMin
            }, [
              _createVNode(_component_ChartJs, {
                options: _ctx.option,
                onChartjsOnlick: _ctx.min30Onclick,
                style: {"height":"50px"}
              }, null, 8, ["options", "onChartjsOnlick"])
            ], 8, _hoisted_26)
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == 'advance')
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipment.sensors, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(
              'col-' +
              (_ctx.equipment.sensors.length % 2 > 0 &&
              index == _ctx.equipment.sensors.length - 1
                ? '12'
                : '6') +
              ' mb-3 text-center'
            ),
                  key: index
                }, [
                  _createElementVNode("b", null, [
                    _createElementVNode("span", {
                      class: "dot",
                      style: _normalizeStyle('background: ' + item.color)
                    }, null, 4),
                    _createTextVNode(" " + _toDisplayString(item.value) + " ", 1),
                    _createElementVNode("span", _hoisted_29, [
                      (_ctx.status(item.last_reading) && item.alarm_type == 77)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "alarm-icon text-warning",
                            title: item.message
                          }, _hoisted_32, 8, _hoisted_30))
                        : (_ctx.status(item.last_reading) && item.alarm_type == 78)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "alarm-icon text-danger",
                              title: item.message
                            }, _hoisted_35, 8, _hoisted_33))
                          : (_ctx.status(item.last_reading))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                class: "alarm-icon text-success",
                                title: item.message
                              }, _hoisted_38, 8, _hoisted_36))
                            : (!_ctx.status(item.last_reading))
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 3,
                                  class: "alarm-icon text-black-50",
                                  title: item.message
                                }, _hoisted_41, 8, _hoisted_39))
                              : _createCommentVNode("", true)
                    ])
                  ]),
                  _hoisted_42,
                  _createElementVNode("small", null, _toDisplayString(item.name) + " (" + _toDisplayString(item.unit) + ")", 1)
                ], 2))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}